export default __webpack_public_path__ + "static/media/idd4.112b2989.png";